import React from 'react'
import Icon from '../../components/Icon'
import Container from '../../components/Container'
import { StyledHint, StyledHintWrapper, StyledHintCopy } from './styled'

const Hint = React.memo(({ copy }) => {
  return (
    <StyledHint>
      <Container>
        <StyledHintWrapper>
          <Icon name="tooltip" />
          <StyledHintCopy>
            {copy}
          </StyledHintCopy>
        </StyledHintWrapper>
      </Container>
    </StyledHint>
  )
})

export default Hint